export default __webpack_public_path__ + "static/media/OBS_Studio_Logo.cc803940.svg";